module.exports = __webpack_public_path__ + "static/media/my.07fd2be8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/my.svg
// module id = 203
// module chunks = 0